<template>
  <v-dialog v-model="isDialogOpened" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text px-4 py-3">
        <v-toolbar-title class="text-h6">CHI TIẾT CÔNG VIỆC</v-toolbar-title>
        <v-spacer />
        <v-btn icon color="white" @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-6 py-4">
        <div class="text-h6 black--text font-weight-medium mb-2">
          {{ taskTitle || 'Chưa có tiêu đề' }}
        </div>

        <v-card class="mb-2 py-2 px-4 grey lighten-4" flat>
          <div class="text-subtitle-1 font-weight-medium">
            {{ taskContent || 'Chưa có nội dung' }}
          </div>
        </v-card>

        <v-list dense>
          <v-list-item>
            <v-list-item-content class="d-flex flex-row align-center">
              <v-list-item-subtitle class="text-subtitle-1 font-weight-medium mr-2"> Người giao </v-list-item-subtitle>
              <v-list-item-title class="font-weight-regular">
                {{ creatorName || 'Chưa có thông tin' }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2" />

          <v-list-item>
            <v-list-item-content class="d-flex flex-row align-center">
              <v-list-item-subtitle class="text-subtitle-1 font-weight-medium mr-2"> Người nhận </v-list-item-subtitle>
              <v-list-item-title class="font-weight-regular">
                {{ receiverName || 'Chưa có thông tin' }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2" />

          <v-list-item>
            <v-list-item-content class="d-flex flex-row align-center">
              <v-list-item-subtitle class="text-subtitle-1 font-weight-medium mr-2"> Bắt đầu từ: </v-list-item-subtitle>
              <v-list-item-title class="font-weight-regular">
                {{ startTime || 'Chưa có thông tin' }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2" />

          <v-list-item>
            <v-list-item-content class="d-flex flex-row align-center">
              <v-list-item-subtitle class="text-subtitle-1 font-weight-medium mr-2">
                Kết thúc trước:
              </v-list-item-subtitle>
              <v-list-item-title class="font-weight-regular">
                {{ endTime || 'Chưa có thông tin' }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="task.category === 'done'" class="my-2" />

          <v-list-item v-if="task.category === 'done'">
            <v-list-item-content>
              <v-list-item-subtitle class="text-subtitle-1 font-weight-medium">
                Đánh giá:
                <v-chip class="ml-2" :color="getEvaluationColor" dark small>
                  {{ getEvaluation }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { find, get } from 'lodash-es'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import mixins from '../helper/mixins'

export default {
  name: 'TaskDetailDialog',
  mixins: [mixins],

  data() {
    return {
      isDialogOpened: false,
      task: {},
    }
  },

  computed: {
    ...mapState('task', ['tasks']),
    ...mapGetters('task', ['contributorsByID']),

    taskTitle() {
      return get(this.task, 'title', '')
    },

    taskContent() {
      return get(this.task, 'content', '')
    },

    creatorName() {
      const creatorID = get(this.task, 'creator.id', null)
      return creatorID && this.contributorsByID[creatorID] ? this.contributorsByID[creatorID].name : ''
    },

    receiverName() {
      const receiverID = get(this.task, 'receiver.id', null)
      return receiverID && this.contributorsByID[receiverID] ? this.contributorsByID[receiverID].name : ''
    },

    startTime() {
      const date = moment(get(this.task, 'startTime', ''))
      return date.isValid() ? date.format('DD/MM/YYYY') : ''
    },

    endTime() {
      const date = moment(get(this.task, 'endTime', ''))
      return date.isValid() ? date.format('DD/MM/YYYY') : ''
    },

    getEvaluation() {
      if (!this.task.evaluate) return 'Chưa đánh giá'

      const evaluationMap = {
        10: 'A+',
        9: 'A',
        8: 'A-',
        7: 'B+',
        6: 'B',
        5: 'B-',
        4: 'C+',
        3: 'C',
        2: 'C-',
      }

      for (const [score, grade] of Object.entries(evaluationMap)) {
        if (this.task.evaluate >= score) return grade
      }
      return 'D'
    },

    getEvaluationColor() {
      if (!this.task.evaluate) return 'grey'
      if (this.task.evaluate >= 8) return 'success'
      if (this.task.evaluate >= 5) return 'warning'
      return 'error'
    },
  },

  methods: {
    cancel() {
      this.isDialogOpened = false
    },

    openDialog(taskID) {
      this.task = find(this.tasks, { id: taskID })
      if (this.task) {
        this.isDialogOpened = true
      }
    },
  },
}
</script>
